import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';
import styled, { css } from "styled-components";
import LoadingOverlay from "react-loading-overlay";
import { ToastContainer, toast } from 'react-toastify';
import { StyledSearchBarPlatforms, StyledSearchIcon } from "../../fui/FuiStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Divider from "@material-ui/core/Divider";
import Axios from "axios";
import { tokenValidation } from "../../../helper/customizedHooks";
import base from "../../../config";
import { headers } from "../../../helper/api";
import { CircularProgress, Typography, Box } from "@material-ui/core";
import { StyledTablePagination } from "../../ec2management/StyledEc2ManagementComponent";
import OrdersAdminPageData from "./OrdersAdminPageData";


/**
 * @author Poornna Aiswarya Ganeshan
 * @version 1.0
 * @see Used in component: Admin
 */

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
    },
    table: {
        minWidth: 500,
    },
    tableWrapper: {
        overflow: 'auto',
    },
});

const DarkBackground = styled.div`
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */

  ${(props) =>
        props.disappear &&
        css`
      display: block; /* show */
    `}
`;

const OrdersAdminPage = (email, idToken) => {
    const [isLoading, setIsLoading] = useState(true);
    const [loaded, setLoaded] = useState(true);
    const [searchQuery, setSearchQuery] = useState("");
    const [approvalRequestList, setApprovalRequestList] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(
        localStorage.getItem("rowsPerPage") === null
            ? 5
            : localStorage.getItem("rowsPerPage")
    );
    // const classes = useStyles();

    useEffect(() => {
        let timer;
        if (email && idToken) {
            fetchApprovalRequestList(email);
            timer = setInterval(() => {
                const apiCall = () => {
                    tokenValidation();
                    fetchApprovalRequestList(email);
                };
                apiCall();
            }, 5000);
            return () => clearInterval(timer);
        }
    }, [email, idToken]);

    const fetchApprovalRequestList = async () => {
        const idToken = localStorage.getItem("token");
        const customerEnterpriseId = email.email.split("@")[0];
        if (customerEnterpriseId && idToken) {
            return Axios
                .get(
                    `${base.urls.apis.fulfillment}` +
                    `/failedorders?userepid=${customerEnterpriseId}`,
                    {
                        headers: { ...headers, Authorization: idToken },
                    }
                )
                .then((res) => {
                    setIsLoading(false)
                    const data = res.data;
                    setApprovalRequestList(data)
                })
                .catch((err) => {
                    //toast.error("ERROR! Please try again after sometime.");
                    console.log("Async error", err);
                });
        }
    };

    // const sortedApprovalsData = approvalRequestList ? approvalRequestList.sort((a, b) => new Date(b.OrderItems[0].CreatedDate) - new Date(a.OrderItems[0].CreatedDate)) : undefined;

    let filteredOrders =
        approvalRequestList &&
        approvalRequestList.filter((item) => {
            if (searchQuery === "*") {
                return item;
            } else if (
                item.OrderItems[0].OrderItemUId.toLowerCase().indexOf(searchQuery.toLowerCase()) !== -1 ||
                item.OrderItems[0].Config.find(item => item.Key === "CustomerEnterpriseID")['Value'].toLowerCase().indexOf(searchQuery.toLowerCase()) !==
                -1 ||
                item.OrderItems[0].Config.find(item => item.Key === "DomainContextRoot")['Value'].toLowerCase().indexOf(searchQuery.toLowerCase()) !==
                -1 ||
                // item.OrderItems[0].Config.find(item => item.Key === "SAPContractId")['Value'].toLowerCase().indexOf(searchQuery.toLowerCase()) !==
                // -1 ||
                // item.OrderItems[0].Config.find(item => item.Key === "SAPContractID")['Value'].toLowerCase().indexOf(searchQuery.toLowerCase()) !==
                // -1 ||
                item.OrderItems[0].Config.find(item => item.Key === "WBSEcode")['Value'].toLowerCase().indexOf(searchQuery.toLowerCase()) !==
                -1 ||
                item.OrderItems[0].Config.find(item => item.Key === "ClientName")['Value'].toLowerCase().indexOf(searchQuery.toLowerCase()) !==
                -1 ||
                item.OrderItems[0].Config.find(item => item.Key === "ApprovalStatus")['Value'].toLowerCase().indexOf(searchQuery.toLowerCase()) !==
                -1
            ) {
                return item;
            } else {
                return null;
            }
        })

    const sortFilteredInstances = filteredOrders ? filteredOrders : ""

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(event.target.value);
        localStorage.setItem("rowsPerPage", event.target.value);
        setPage(0);
    };

    return (
        <div>
            <div className="mainDiv">
                <DarkBackground disappear={!loaded}>
                    <LoadingOverlay
                        active={true}
                        spinner={true}
                    >
                    </LoadingOverlay>
                </DarkBackground>
                <ToastContainer autoClose={7000} />
            </div>
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                p={2}
            >
                <Typography variant="h4" gutterBottom>
                    Order Handling
                </Typography>

                {/* Search Bar */}
                <div>
                    <StyledSearchBarPlatforms
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        id="outlined-search"
                        type="search"
                        margin="normal"
                        placeholder="Search for Order ID, Domain Context Root, Customer Enterprise ID..."
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <StyledSearchIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                </div>
            </Box>
            <Divider />

            {/* Main Table */}
            <div>
                {isLoading ?
                    <div id="loader"
                        style={{
                            paddingTop: "10%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <CircularProgress size={40} />
                    </div>
                    :
                    <div>
                        <br></br>
                        <br></br>
                        {sortFilteredInstances.length > 0 ?
                            <div>
                                <OrdersAdminPageData
                                    stuckOrdersList={sortFilteredInstances}
                                    email={email}
                                    idToken={idToken}
                                    page={page}
                                    rowsPerPage={rowsPerPage}
                                />
                                <StyledTablePagination
                                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                                    component="div"
                                    count={sortFilteredInstances && sortFilteredInstances.length}
                                    rowsPerPage={parseInt(rowsPerPage, 10)}
                                    page={page}
                                    backIconButtonProps={{
                                        "aria-label": "Previous Page",
                                    }}
                                    nextIconButtonProps={{
                                        "aria-label": "Next Page",
                                    }}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handleChangeRowsPerPage}
                                />
                            </div>
                            :
                            <div style={{ alignContent: "left" }}>
                                <h3 style={{ textAlign: "left", fontFamily: "Graphik", paddingTop: "10px", fontWeight: "500" }}>There are no stuck orders to replay!</h3>
                            </div>
                        }

                    </div>
                }
            </div>

        </div>
    )
}

OrdersAdminPage.propTypes = {
    /**
     * Current users email
     */
    email: PropTypes.string,
};


const MSTP = (state) => ({
    email: state.auth.userDetails.email,
    idToken: state.auth.idToken,

});

export default connect(MSTP)(withRouter(withStyles(styles)(OrdersAdminPage)));
